import { useCallback, useEffect } from "react";

import { useMonitoringStore } from "../@modules/monitor/monitoringStore";

export const useIsFullscreen = () => {
  const isFullscreen = useMonitoringStore((s) => s.isFullscreen);
  const setIsFullscreen = useMonitoringStore((s) => s.setIsFullscreen);

  const handleChange = useCallback(() => {
    setIsFullscreen(!!document.fullscreenElement);
  }, [setIsFullscreen]);

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleChange);
    };
  }, [handleChange]);

  return isFullscreen;
};
